import { useTranslation } from 'react-i18next';
import Style from '../assets/css/social.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook , faInstagram, faLinkedin , faThreads, faTiktok, faYoutube } from '@fortawesome/free-brands-svg-icons';


const Sponsors = () => {
    const { t } = useTranslation();

    const sponsorCategories = [
        { icon: faFacebook, url:'https://www.facebook.com/share/19q6Mjqtcf/' },
        { icon: faInstagram, url:'https://www.instagram.com/mixtecnautas?igsh=MXR5a3Bnc3p2NWIxdg==' }, 
        { icon: faYoutube, url:'https://www.youtube.com/@Mixtecnautas' } ,
        { icon: faLinkedin, url:'https://www.linkedin.com/company/mixtecnautas/' } ,
        { icon: faThreads, url:'https://www.threads.com/@mixtecnautas' } ,
        { icon: faTiktok, url:'https://www.tiktok.com/@mixtecnautas' } ,
    ];

    return (
        <section className={Style.titleSection}>
            <div className={Style.mainHeader}>
                <h1 className={Style.mainTitle}>{t('redes')}</h1>
            </div>

            <div className={Style.sponsorCategories}>
                {sponsorCategories.map((category, index) => (
                    <div key={index} className={Style.categoryCard}>
                         <a 
                            href={category.url} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className={Style.categoryLink}
                        >
                            <div className={Style.categoryIcon}>
                            <FontAwesomeIcon icon={category.icon} />
                            </div>
                        </a>
                    </div>
                ))}
            </div>

           
        </section>
    );
};

export default Sponsors;